<template>
  <div class="select-network-error__container">
    <div class="mb-4">{{ networkErrorText }}</div>
    <div>
      <v-btn depressed color="primary" :disabled="loading" @click="retry">
        <v-icon left>
          mdi-refresh
        </v-icon>
        {{ $t('select.retry') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['retry', 'loading', 'networkErrorText'],
};
</script>

<style>
.select-network-error__container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
